import {
  CANVAS_FOLDER_SECTION_OFFSET_X,
  bucketFolderTreeIntoSections,
} from "@/pages/canvas/utils/canvasFolderSections";
import type { FolderUploadTree } from "@/utils/traverseDataTransferItems";
import { useCallback } from "react";
import { useCanvasFileIngest } from "./useCanvasFileIngest";

/**
 * Places a folder tree on the canvas: loose top-level files in a grid at
 * `at`, then one section per top-level folder stepping right from there.
 * Shared by the OS folder drop and the Insert menu's folder picker.
 */
export function useCanvasFolderIngest(canvasId: string | undefined) {
  const { ingestFiles } = useCanvasFileIngest(canvasId);

  const ingestFolderTree = useCallback(
    async (tree: FolderUploadTree, at: { x: number; y: number }) => {
      if (tree.looseFiles.length > 0) {
        await ingestFiles(tree.looseFiles, {
          placement: { strategy: "grid", at },
        });
      }

      let offsetX = 0;
      for (const { folderName, files } of bucketFolderTreeIntoSections(tree)) {
        await ingestFiles(files, {
          placement: {
            strategy: "gridInSection",
            at: { x: at.x + offsetX, y: at.y },
            sectionName: folderName,
          },
        });
        offsetX += CANVAS_FOLDER_SECTION_OFFSET_X;
      }
    },
    [ingestFiles],
  );

  return { ingestFolderTree };
}
